export default __webpack_public_path__ + "media/flavours/glitch/images/friends-cropped-40409bf96999902fa49757ebce824ce6.png";